/**
 * 탭 좌상단 ?(도움말) 버튼 → 재생할 튜토리얼 scenarioId 결정 (순수 함수).
 *
 * 탭별 시나리오는 `scenarioId = TabId` 컨벤션을 따르지만, 전투(battle) 탭은 전용 탭 튜토리얼이
 * 없고 게임 핵심(필드·파이프·연결)을 설명하는 메인 튜토리얼(main)이 그 역할을 한다. 그래서
 * battle만 main으로, 나머지는 자기 TabId로 매핑한다. 호출자(GameScene onHelp)는 이 값을
 * `startTutorial(scenarioId)`(forceReplay)에 넘겨 완료 여부와 무관하게 다시 보여준다.
 */
import type { TabId } from "../ui/tabVisibility.js";

export function tabHelpScenarioId(tab: TabId): string {
  return tab === "battle" ? "main" : tab;
}
